import getProfileRoles from "./getProfileRoles";
import getAdditionalInformation from "./getAdditionalInformation";

const ProfileRoles = {
  getProfileRoles,
  getAdditionalInformation,
};

export default ProfileRoles;
